<template>
  <div class="make-payment-container">
    <div id="top-target" class="bill-pay-success-fail">
      <div class="bill-pay-success__intro-image">
        <img class="my-account__payment-plan-icon" src="/wp-content/themes/gmptwentynineteen/assets/images/bill-pay-complete.svg" alt="successful payment" />
      </div>

      <h2 class="gds-display-2 gds-align--text-center gds-space-stack-ml">Thank you!</h2>
      <div class="gds-font-size-l gds-space-stack-l">
        Your payment of {{paymentAmount | currency}} was successfully processed. It may take up to 48 hours before the payment is reflected in your account balance. If your service is scheduled to be shut off in the next 48 hours, or if your service has already been shut-off for non-payment, please contact Green Mountain Power at
        <span class="gds-nobreak">{{GMPPhoneNumber}}</span> to report this payment.
      </div>
      <div class="bill-pay-success__receipt gds-space-stack-l">
        <p class="gds-body-small gds-align--text-center gds-text-grey gds-space-stack-s">Confirmation Number</p>
        <p class="gds-body-normal gds-align--text-center">{{confirmationNumber}}</p>
      </div>
      <div class="bill-pay-success__button-wrap gds-align--text-center">
        <button @click="ReturnToSender('/make-payment')" type="button" class="bill-pay-success__button gds-button">Done</button>
      </div>
    </div>
  </div>
</template>

<script>
import { GMPPhoneNumber } from "../../environment";
import { ReturnToSender } from "../../utilities";

export default {
  name: "BillPayComplete",
  data() {
    return {
      ReturnToSender,
      GMPPhoneNumber,
    };
  },
  computed: {
    paymentAmount() {
      return this.$store.state.billpay.paymentAmount;
    },
    confirmationNumber() {
      return this.$store.state.billpay.confirmationNumber;
    },
  },
  async mounted() {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>